module.exports = __webpack_public_path__ + "media/dashboard/assets/images/phone-hangup-98512a19bfbc0fdfc55416cdec22d169.svg";